import { render, staticRenderFns } from "./DealModalHeader.vue?vue&type=template&id=79ed4a5b"
import script from "./DealModalHeader.vue?vue&type=script&lang=js"
export * from "./DealModalHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports